module.exports = __webpack_public_path__ + "img/history_lose.7e4210a2.png";